export const LIST_ABNORMAL_DESCRIPTION_REQUEST = 'LIST_ABNORMAL_DESCRIPTION_REQUEST'
export const LIST_ABNORMAL_DESCRIPTION_SUCCESS = 'LIST_ABNORMAL_DESCRIPTION_SUCCESS'
export const LIST_ABNORMAL_DESCRIPTION_FAILURE = 'LIST_ABNORMAL_DESCRIPTION_FAILURE'

export const LIST_ABNORMAL_DESCRIPTION_SUMMARY_REQUEST = 'LIST_ABNORMAL_DESCRIPTION_SUMMARY_REQUEST'
export const LIST_ABNORMAL_DESCRIPTION_SUMMARY_SUCCESS = 'LIST_ABNORMAL_DESCRIPTION_SUMMARY_SUCCESS'
export const LIST_ABNORMAL_DESCRIPTION_SUMMARY_FAILURE = 'LIST_ABNORMAL_DESCRIPTION_SUMMARY_FAILURE'

export const CREATE_ABNORMAL_DESCRIPTION_REQUEST = 'CREATE_ABNORMAL_DESCRIPTION_REQUEST'
export const CREATE_ABNORMAL_DESCRIPTION_SUCCESS = 'CREATE_ABNORMAL_DESCRIPTION_SUCCESS'
export const CREATE_ABNORMAL_DESCRIPTION_FAILURE = 'CREATE_ABNORMAL_DESCRIPTION_FAILURE'

export const DETAIL_ABNORMAL_DESCRIPTION_REQUEST = 'DETAIL_ABNORMAL_DESCRIPTION_REQUEST'
export const DETAIL_ABNORMAL_DESCRIPTION_SUCCESS = 'DETAIL_ABNORMAL_DESCRIPTION_SUCCESS'
export const DETAIL_ABNORMAL_DESCRIPTION_FAILURE = 'DETAIL_ABNORMAL_DESCRIPTION_FAILURE'

export const UPDATE_ABNORMAL_DESCRIPTION_REQUEST = 'UPDATE_ABNORMAL_DESCRIPTION_REQUEST'
export const UPDATE_ABNORMAL_DESCRIPTION_SUCCESS = 'UPDATE_ABNORMAL_DESCRIPTION_SUCCESS'
export const UPDATE_ABNORMAL_DESCRIPTION_FAILURE = 'UPDATE_ABNORMAL_DESCRIPTION_FAILURE'

export const DELETE_ABNORMAL_DESCRIPTION_REQUEST = 'DELETE_ABNORMAL_DESCRIPTION_REQUEST'
export const DELETE_ABNORMAL_DESCRIPTION_SUCCESS = 'DELETE_ABNORMAL_DESCRIPTION_SUCCESS'
export const DELETE_ABNORMAL_DESCRIPTION_FAILURE = 'DELETE_ABNORMAL_DESCRIPTION_FAILURE'

export const LIST_DETAIL_ABNORMAL_DESCRIPTION_REQUEST = 'LIST_DETAIL_ABNORMAL_DESCRIPTION_REQUEST'
export const LIST_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS = 'LIST_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS'
export const LIST_DETAIL_ABNORMAL_DESCRIPTION_FAILURE = 'LIST_DETAIL_ABNORMAL_DESCRIPTION_FAILURE'

export const CREATE_DETAIL_ABNORMAL_DESCRIPTION_REQUEST = 'CREATE_DETAIL_ABNORMAL_DESCRIPTION_REQUEST'
export const CREATE_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS = 'CREATE_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS'
export const CREATE_DETAIL_ABNORMAL_DESCRIPTION_FAILURE = 'CREATE_DETAIL_ABNORMAL_DESCRIPTION_FAILURE'

export const DETAIL_DETAIL_ABNORMAL_DESCRIPTION_REQUEST = 'DETAIL_DETAIL_ABNORMAL_DESCRIPTION_REQUEST'
export const DETAIL_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS = 'DETAIL_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS'
export const DETAIL_DETAIL_ABNORMAL_DESCRIPTION_FAILURE = 'DETAIL_DETAIL_ABNORMAL_DESCRIPTION_FAILURE'

export const UPDATE_DETAIL_ABNORMAL_DESCRIPTION_REQUEST = 'UPDATE_DETAIL_ABNORMAL_DESCRIPTION_REQUEST'
export const UPDATE_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS = 'UPDATE_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS'
export const UPDATE_DETAIL_ABNORMAL_DESCRIPTION_FAILURE = 'UPDATE_DETAIL_ABNORMAL_DESCRIPTION_FAILURE'

export const DELETE_DETAIL_ABNORMAL_DESCRIPTION_REQUEST = 'DELETE_DETAIL_ABNORMAL_DESCRIPTION_REQUEST'
export const DELETE_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS = 'DELETE_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS'
export const DELETE_DETAIL_ABNORMAL_DESCRIPTION_FAILURE = 'DELETE_DETAIL_ABNORMAL_DESCRIPTION_FAILURE'

export const RESET_ABNORMAL_DESCRIPTION = 'RESET_ABNORMAL_DESCRIPTION'

